import React from 'react'
import {
  FormDashboardLabel as Label,
  FormRow,
  SaveButton,
  VisibilityCheckboxes as Checkboxes,
} from '../../../components'
// import { viewportBreakpoint, useViewport } from '../../../utils'

const ContentGeneral = () => {
  // const { width } = useViewport()
  // const isMobile = width < viewportBreakpoint.tablet

  return (
    <div className="w-full pb-10 lg:pb-0">
      <FormRow>
        <div className="mb-5 lg:mb-10">
          <Label>Title</Label>
          <div className="pt-3">
            <Checkboxes name="title"/>
          </div>
        </div>
      </FormRow>
      <FormRow>
        <div className="mb-5 lg:mb-10">
          <Label>Main Image</Label>
          <div className="pt-3">
            <Checkboxes name="main_image"/>
          </div>
        </div>
      </FormRow>
      <FormRow>
        <div className="mb-5 lg:mb-10">
          <Label>Thumbnail</Label>
          <div className="pt-3">
            <Checkboxes name="thumbnail"/>
          </div>
        </div>
      </FormRow>
      <FormRow>
        <div className="mb-5 lg:mb-10">
          <Label>Other variables</Label>
          <div className="pt-3">
            <Checkboxes name="other"/>
          </div>
        </div>
      </FormRow>
      <SaveButton />
    </div>
  )
}

export { ContentGeneral }